import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="mb-3 text-lg font-bold text-[#0A192F]">{title}</h2>
    <div className="space-y-2 text-sm leading-7 text-slate-600">{children}</div>
  </section>
);

export default function TermsPage() {
  const navigate = useNavigate();
  const [contactEmail, setContactEmail] = useState('');

  useEffect(() => {
    axios.get(`${API}/platform/settings`).then((res) => {
      if (res.data?.contact_email) setContactEmail(res.data.contact_email);
    }).catch(() => {});
  }, []);

  return (
    <div dir="rtl" className="min-h-screen bg-slate-50" data-testid="terms-page">
      <header className="border-b border-slate-200 bg-white px-6 py-4">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <button onClick={() => navigate(-1)} data-testid="terms-back-btn" className="text-sm font-semibold text-teal-600 hover:underline">
            ← رجوع
          </button>
          <span className="font-bold text-[#0A192F]">تسيار</span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="mb-2 text-2xl font-bold text-[#0A192F]" data-testid="terms-title">الشروط والأحكام</h1>
        <p className="mb-8 text-xs text-slate-400">آخر تحديث: {new Date().toLocaleDateString('ar-SA')}</p>

        <Section title="1. قبول الشروط">
          <p>
            باستخدامك منصة «تسيار» لإدارة الأندية والأكاديميات الرياضية، سواء بإنشاء حساب منشأة جديد أو حساب مدرب
            أو موظف تابع لمنشأة مسجّلة، فإنك توافق على هذه الشروط والأحكام وعلى سياسة الخصوصية الخاصة بالمنصة.
          </p>
        </Section>

        <Section title="2. طبيعة الخدمة">
          <p>
            تقدّم المنصة أداة إدارية (SaaS) لمساعدة الأندية والأكاديميات الرياضية على إدارة اللاعبين والفرق والفئات
            والحضور والمباريات والموارد البشرية والشؤون المالية الداخلية والتقارير، ضمن بيئة معزولة لكل منشأة.
          </p>
        </Section>

        <Section title="3. مسؤولية المنشأة عن بياناتها">
          <p>
            تبقى المنشأة (النادي أو الأكاديمية) المسؤول الوحيد عن دقة البيانات التي تُدخلها في النظام (بيانات اللاعبين،
            الموظفين، الاشتراكات، المعاملات المالية)، وعن الحصول على أي موافقات لازمة من أولياء الأمور أو المستخدمين
            المرتبطين بها بحسب الأنظمة المحلية المعمول بها.
          </p>
        </Section>

        <Section title="4. الحسابات والصلاحيات">
          <p>
            يلتزم كل مستخدم بالحفاظ على سرية بيانات تسجيل الدخول الخاصة به، وعدم مشاركتها مع أي طرف آخر. تتم إدارة
            إنشاء الحسابات الفردية (المدربين، الموظفين) وإعادة تعيين كلمات المرور من قِبل مدير المنشأة.
          </p>
        </Section>

        <Section title="5. الفترة التجريبية والاشتراك">
          <p>
            قد تُقدَّم المنصة بفترة تجريبية مجانية محدودة للمنشآت الجديدة. يخضع استمرار الاستخدام بعد انتهاء الفترة
            التجريبية لخطة الاشتراك المتاحة وقتها، ويُعلَم مدير المنشأة بأي تغييرات تخص خطته.
          </p>
        </Section>

        <Section title="6. الاستخدام المقبول">
          <p>
            يُمنع استخدام المنصة لأي غرض غير مشروع، أو لمحاولة الوصول غير المصرَّح به إلى بيانات منشأة أخرى، أو
            الإضرار بسلامة النظام أو باقي المستخدمين.
          </p>
        </Section>

        <Section title="7. تعديل الشروط">
          <p>
            قد تُحدَّث هذه الشروط من وقت لآخر لمواكبة تطوّر خدمات المنصة، وسيُشار إلى تاريخ آخر تحديث في أعلى هذه
            الصفحة. استمرار استخدامك للمنصة بعد أي تحديث يُعدّ موافقة على الشروط المحدَّثة.
          </p>
        </Section>

        <Section title="8. التواصل">
          <p>
            لأي استفسار بخصوص هذه الشروط{contactEmail ? <> يمكن التواصل عبر <span dir="ltr" className="font-semibold">{contactEmail}</span></> : '، يرجى التواصل مع مدير المنشأة الخاصة بك أو الجهة المشغّلة للمنصة'}.
          </p>
        </Section>
      </main>
    </div>
  );
}
